import { render, staticRenderFns } from "./SecondGraduationInstitutionInfoForm.vue?vue&type=template&id=26503e18&scoped=true&"
import script from "./SecondGraduationInstitutionInfoForm.vue?vue&type=script&lang=ts&"
export * from "./SecondGraduationInstitutionInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGraduationInstitutionInfoForm.vue?vue&type=style&index=0&id=26503e18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26503e18",
  null
  
)

export default component.exports